var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_1470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7927 15.7914L12.5646 11.5634C13.7168 10.1542 14.2833 8.35608 14.1469 6.54096C14.0106 4.72583 13.1817 3.03256 11.8319 1.81139C10.4821 0.590212 8.71455 -0.0654344 6.89488 -0.0199368C5.0752 0.0255607 3.34263 0.768721 2.05552 2.05583C0.768416 3.34293 0.0252555 5.07551 -0.020242 6.89518C-0.0657396 8.71485 0.589907 10.4824 1.81108 11.8322C3.03225 13.182 4.72553 14.0109 6.54065 14.1472C8.35578 14.2836 10.1539 13.7171 11.563 12.5649L15.7911 16.793C15.9247 16.922 16.1036 16.9934 16.2893 16.9918C16.4751 16.9902 16.6527 16.9157 16.784 16.7843C16.9154 16.653 16.9899 16.4754 16.9915 16.2896C16.9931 16.1039 16.9217 15.925 16.7927 15.7914ZM7.08355 12.7505C5.96278 12.7505 4.86719 12.4182 3.93531 11.7955C3.00344 11.1729 2.27712 10.2878 1.84823 9.25239C1.41933 8.21694 1.30711 7.07756 1.52576 5.97834C1.74441 4.87911 2.28411 3.86941 3.07661 3.07691C3.8691 2.28441 4.87881 1.74472 5.97803 1.52607C7.07726 1.30742 8.21664 1.41964 9.25209 1.84853C10.2875 2.27743 11.1725 3.00374 11.7952 3.93562C12.4179 4.8675 12.7502 5.96309 12.7502 7.08385C12.7485 8.58623 12.151 10.0266 11.0886 11.0889C10.0263 12.1513 8.58592 12.7488 7.08355 12.7505Z",
    fill: "#797979"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_1470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchField);
export default __webpack_public_path__ + "static/media/search-field.bb3b282f6619168c082e341570ada56a.svg";
export { ForwardRef as ReactComponent };